import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export function InfoTip({ text, testid }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" aria-label="How this is calculated" data-testid={testid || "info-tip"}
          className="inline-flex items-center text-zinc-400 hover:text-zinc-700 align-middle">
          <Info className="w-3.5 h-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 text-xs leading-relaxed text-zinc-700" side="top">{text}</PopoverContent>
    </Popover>
  );
}

export const RATE_FORMULAS = {
  quote_book_rate: "Quote Book Rate = unique estimates created in the period with ≥1 appointment created within 30 days (any channel: online, text, phone, Rosie, manual) ÷ unique estimates created in the period. One estimate per person (latest).",
  online_self_book_rate: "Online Self-Book Rate (online only) = unique funnel estimates booked through the online booking step ÷ unique estimates shown in the online funnel.",
  close_rate_paid: "Close Rate (paid) = unique estimates created in the period whose customer has a paid invoice ÷ unique estimates created in the period.",
  paid_over_booked: "Paid ÷ Booked = booked estimates (appointment within 30 days) that also have a paid invoice ÷ booked estimates.",
  estimate_view_rate: "Saw Estimate % = funnel visits that reached the quote ÷ funnel visits. (Visits measure traffic only — never used for booking or close rates.)",
  online_bookings: "Appointments created through the online booking step in this period (the thank-you page alone doesn't count).",
};
